let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Tmeq")).then(() => parcelRequire('c9IZL'));